import React from "react";

interface Props {
  title: string;
  description?: string;
  children: React.ReactElement;
  descriptionWidthClass?: string;
}

export default function EditorDescriptor({
  title,
  description,
  children,
  descriptionWidthClass,
}: Props): React.ReactElement {
  return (
    <div className="flex flex-col items-left md:items-center">
      <span className="font-extrabold text-4xl mb-4 md:mb-6">{title}</span>
      {description && (
        <span
          className={`font-normal text-lg mb-8 md:text-center ${
            descriptionWidthClass ?? ""
          }`}
        >
          {description}
        </span>
      )}
      <div className="w-full">{children}</div>
    </div>
  );
}
